/**
 * Sovella CookieHub javascript
 */
(function ($, Drupal) {

  "use strict";

  var chBlockedContent = $('.field--type-video-embed-field, a.video-link, .juicer-feed');
  var chBlockedMessage = Drupal.t('Please allow marketing cookies to view content.');
  var chBlockedContentPlaceholder = '<div class="ch-blocked-content" data-consent="marketing" data-inverse>' + chBlockedMessage + '</div>'

  if (chBlockedContent.length) {
    chBlockedContent.each(function() {
      $(this).wrap('<div class="ch-blocked-content-wrapper"></div>')
      $(this).before(chBlockedContentPlaceholder);
    });
  }
})(jQuery, Drupal);
